import * as React from 'react';
import { ProfitItemLayout, DreamItem } from '../../components/ProfitItem';
import { useDreamProps, useDailyRentProps, useDepositProps, useRentProps } from './hooks';

export const ProfitContainer: React.FC = () => {
  const rentProps = useRentProps();
  const dailyRentProps = useDailyRentProps();
  const depositProps = useDepositProps();
  const dreamProps = useDreamProps();

  return (
    <div>
      {rentProps && <ProfitItemLayout {...rentProps} />}

      {dailyRentProps && <ProfitItemLayout {...dailyRentProps} />}

      {depositProps && (
        <>
          <DreamItem {...dreamProps} />
          <ProfitItemLayout {...depositProps} />
        </>
      )}
    </div>
  );
};
